<template>
  <div>
    <site-header/>
    <product-detail :product="product"/>
    <order-steps/>
    <content-blocks ref="contentBlocks"/>
    <product-slider ref="productSlider"/>
    <site-footer/>
  </div>
</template>

<script>
  import SiteHeader from '@/components/SiteHeader'
  import SiteFooter from '@/components/SiteFooter'
  import OrderSteps from '@/components/OrderSteps'
  import ProductDetail from '@/components/ProductDetail'
  import ProductSlider from '@/components/ProductSlider'
  import ContentBlocks from '@/components/ContentBlocks'

  export default {
    name: 'ProductPage',
    components: {
      ContentBlocks,
      ProductSlider,
      ProductDetail,
      OrderSteps,
      SiteFooter,
      SiteHeader
    },
    data() {
      return {
        product: null
      };
    },
    methods: {
      load: function () {
        const slug = this.$route.params.slug;

        this.$root.$api.getProductBySlug(slug)
          .then(response => {
            if (response.data != null) {
              this.product = response.data.products[0];
              this.$refs.productSlider.introText = "You might also like...";
              this.$refs.productSlider.loadRecommendedProducts(this.product);

              this.trackProductView(this.product);
            }
          }).catch(error => {
          console.log(error);
        })
      },
      loadPageContent: function () {
        this.$root.$api.getPageBySlug('global-content')
          .then(response => {
            if (response.data != null) {
              this.globalContent = response.data.pages[0];
              let contentPanels = [];

              this.globalContent.content.forEach(content => {
                if (content.name.includes('Excellence Panel')) {
                  contentPanels.push(content);
                }
              });

              this.$refs.contentBlocks.loadContent(contentPanels);
            }
          }).catch(error => {
          console.log(error);
        })
      },
      trackProductView: function (product) {
        this.$root.$api.trackProductAnalytic(product.id)
                .catch(error => {
                  console.log(error);
                })
      },
    },
    created: function () {
      this.load();
      this.loadPageContent();
    }
  };
</script>
